import {
	PiecesLengthReportPage,
	BundlesLengthReportPage,
} from "../../pages/reports/length";

export const routeBundlesLengthReport = "/reports/bundles-length";
export const routePiecesLengthReport = "/reports/pieces-length";

export const reportsRoutes = [
	{
		path: routeBundlesLengthReport,
		element: <BundlesLengthReportPage />,
	},
	{
		path: routePiecesLengthReport,
		element: <PiecesLengthReportPage />,
	},
];
